<template>
  <div class="ptStarka-aboutUs">
    <menuBox :step="2"></menuBox>
    <div class="content-top">
      <div class="title">Giới thiệu doanh nghiệp</div>
      <div class="text">Phân loại doanh nghiệp</div>
    </div>
    <div class="info-box">
      <div class="item">
        <div class="left">
          <img src="../assets/about1.png" class="about1" />
          <div class="box">
            <div class="leftTitle">khoản vay cá nhân</div>
            <div class="leftText">Cung cấp các phương án vay linh hoạt cho người dùng cá nhân giúp giải quyết các nhu
              cầu tài trợ đột ngột. Người dùng có thể chọn số tiền vay và chu kỳ trả nợ khác nhau tùy theo nhu cầu của
              mình, đồng thời nhanh chóng phê duyệt và giải ngân các khoản vay, cho phép bạn dễ dàng đối phó với những
              thách thức kinh tế trong cuộc sống hàng ngày.</div>
          </div>
        </div>
        <div class="right">
          <div class="bt">Search Objects</div>
          <div class="line"></div>
          <div class="inputBox">
            <input type="text" placeholder="Search">
            <img src="../assets/about2.png" />
          </div>

        </div>
      </div>
      <div class="item">
        <div class="left">
          <img src="../assets/about3.png" class="about1" />
          <div class="box">
            <div class="leftTitle">Vay tín dụng</div>
            <div class="leftText">Cung cấp các khoản vay không có bảo đảm cho người dùng có hồ sơ tín dụng tốt. Người
              dùng chỉ cần cung cấp thông tin cá nhân cần thiết và hồ sơ tín dụng để nhanh chóng nhận được khoản vay,
              giải quyết các vấn đề tài chính và cải thiện chất lượng cuộc sống.</div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <img src="../assets/about4.png" class="about1" />
          <div class="box">
            <div class="leftTitle">Khoản vay khẩn cấp</div>
            <div class="leftText">Cung cấp các dịch vụ cho vay ngắn hạn, số tiền nhỏ dành riêng cho các tình huống khẩn
              cấp, chẳng hạn như chăm sóc y tế, trường hợp khẩn cấp trong gia đình, v.v. Người dùng có thể nhanh chóng
              nộp đơn và được phê duyệt nhanh chóng, giải quyết áp lực tài chính ngắn hạn và giúp bạn sống sót trong
              những trường hợp khẩn cấp.</div>
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "services" });
    },
  },
};
</script>
<style lang="less" scoped>
.content-top {
  background-image: url(../assets/about.png);
  width: 100%;
  height: 640px;
  background-size: 100% 100%;
  padding: 200px 312px 0 312px;
  overflow: hidden;
  box-sizing: border-box;
  text-align: center;

  .title {
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 56px;
    color: #FFFFFF;
    line-height: 79px;
  }

  .text {
    font-size: 24px;
    color: #E5D806;
    line-height: 33px;
  }
}

.info-box {
  padding: 70px 312px;
  background: #1E1D21;

  .item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 64px;

    .left {
      .about1 {
        width: 856px;
        height: 482px;
      }

      .box {
        width: 856px;
        padding: 30px 32px;
        background: #393939;
        box-sizing: border-box;
      }

      .times {
        margin-bottom: 10px;

        img {
          margin-right: 8px;
          width: 12px;
          height: 12px;
        }

        span {
          font-size: 14px;
          color: #FFFFFF;
          line-height: 16px;
        }
      }

      .leftTitle {
        margin-bottom: 24px;
        font-weight: 700;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 33px;
      }

      .leftText {
        font-size: 16px;
        color: #FFFFFF;
        line-height: 18px;
      }
    }

    .right {
      padding: 32px;
      background: #393939;

      .bt {
        margin-bottom: 12px;
        font-weight: 700;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 26px;
      }

      .line {
        margin-bottom: 30px;
        width: 40px;
        height: 3px;
        background: #E5D806;
      }

      .inputBox {
        display: flex;
        align-items: center;

        input {
          padding: 20px;
          width: 268px;
          height: 55px;
          background: #5C5C5C;
          border: none;
          box-sizing: border-box;
        }

        img {
          width: 55px;
          height: 55px;
          cursor: pointer;
        }
      }
    }
  }

}
</style>
